import { createContext } from 'react'
import type { ChartContextType } from './chartWrapper/chartWrapper'
import { ChartDataContextType } from './chart.typings'


const ChartContext = createContext<ChartContextType | null>(null)

const ChartDataContext = createContext<ChartDataContextType>({
    getData: () => {
        return {}
    }
})

export {
    ChartContext,
    ChartDataContext
}